import Vue from 'vue'
import { directive as onClickaway } from 'vue-clickaway2'

Vue.directive('on-clickaway', onClickaway)
